        function sendRX(){
    $.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
       return null;
    }
    return decodeURI(results[1]) || 0;
    
    }
    $("#202395177977066").on('submit',function (event) {
        event.preventDefault();

        // Get form
        var form = $("#202395177977066")[0];
		var referenceName = $.urlParam('token');
      	if(referenceName == null){
          	$("#upResponse p").text("Please use the unique link we emailed you to upload a PD to your order.");
            $("#upResponse").show();
      		return false;
      	}
        var sendData = new FormData(form);
        sendData.set('q4_orderNumber', referenceName);
        $.ajax({
            type: "POST",
            url: "https://hipaa.jotform.com/submit/202395177977066/",
            data: sendData,
            processData: false,
            contentType: false,
            success: function (data) {	
               $("#upResponse p").text('We have received your PD. Thank you!');
               $("#upResponse").show();
            },
            error: function (e) {
				$("#upResponse p").text('There was an issue uploading your PD. Please contact support.');
               $("#upResponse").show();
            }
        });

    }); 
    $( '.inputfile' ).each( function()
	{
		var $input	 = $( this ),
			$label	 = $input.next( 'label' ),
			labelVal = $label.html();

		$input.on( 'change', function( e )
		{
			var fileName = '';

			if( this.files && this.files.length > 0 )
				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
			else if( e.target.value )
				fileName = e.target.value.split( '\\' ).pop();

			if( fileName )
				$label.find( 'span' ).html( fileName );
			else
				$label.html( labelVal );
		});

		// Firefox bug fix
		$input
		.on( 'focus', function(){ $input.addClass( 'has-focus' ); })
		.on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
	});
    }
$(document).ready(function(){
sendRX();
});